import { useEffect } from 'react';

import { Form } from 'antd';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useListCompanies } from '@/hooks/v1/useListCompanies';
import { NamePath } from 'antd/es/form/interface';

interface CompanyProps {
	fieldName?: string | string[];
}

const { useFormInstance, useWatch } = Form;

export function useCompany({ fieldName }: CompanyProps) {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();

	const {
		isLoading,
		isFetching,
		data: companies,
		isError
	} = useListCompanies({ organization_id: organization.id!, company_id: company.id! });

	const field = Array.isArray(fieldName) ? fieldName[0] : null;

	const companyId = useWatch(field ? [field, 'company_id'] : 'company_id');

	useEffect(() => {
		if (!companyId) {
			form.setFieldValue(fieldName as NamePath, company.id);
		}
	}, [companyId, form, fieldName]);

	function handleOnChange(id: string): void {
		form.setFieldValue(field ? [field, 'company_id'] : ['company_id'], id);
		form.setFieldValue(field ? [field, 'sector_id'] : ['sector_id'], undefined);
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], undefined);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	function handleOnClear(): void {
		form.setFieldValue(field ? [field, 'company_id'] : ['company_id'], undefined);
		form.setFieldValue(field ? [field, 'sector_id'] : ['sector_id'], undefined);
		form.setFieldValue(field ? [field, 'line_id'] : ['line_id'], undefined);
		form.setFieldValue(field ? [field, 'workstation_id'] : ['workstation_id'], undefined);
		form.setFieldValue(field ? [field, 'activity_id'] : ['activity_id'], undefined);
	}

	const items =
		companies?.map((company: { id: string; name: string }) => ({
			value: company.id,
			label: company.name
		})) || [];

	return {
		items,
		isLoading,
		isFetching,
		isError,
		companyId,
		handleOnChange,
		handleOnClear
	};
}
